import {MockController} from "./MockController";
import {CubeController} from "./CubeController";

export function getController() {

    const urlParams = new URLSearchParams(window.location.search);
    const controller = urlParams.get("controller");

    // Support for legacy value `cube`. This means controller runs at localhost
    if (controller == "cube") {
        return new CubeController("localhost");
    }
    // To use a cube controller, the hostname where it runs on should be specified as value of `controller`
    else if (controller) {
        return new CubeController(controller);
    }

    // Otherwise, use a mock controller (for dev or demo purposes)
    return new MockController();
}